import { generateActions } from "utils/generateActions";

export const GET_TABLE_REVIEWS = generateActions("GET_TABLE_REVIEWS");
export const UPLOAD_REVIEWS = generateActions("UPLOAD_REVIEWS");